import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { useTheme } from '../../../../../theming/useTheme';
import { getGeneratedGlobalStyles } from '../../../../../typography/globalTypographyStyles';
import { ChevronIcon, Directions } from '../ChevronIcon';
import { HeaderLinksDataProps } from '../Header';
import { DropDownMenu } from '../DropDownMenu';

const componentConfigThemeKey = 'moreLinks';

export interface MoreLinksProps {
  moreLinksText: string
  links: HeaderLinksDataProps[]
    pagePath: string
}

export interface MoreLinksThemeProps {
  titleColor: string
  menuBackground: string
  linkColor: string
  hoverColor: string
}

export type MoreLinksComponentProps = MoreLinksThemeProps & MoreLinksProps;

const getStyle = (theme: MoreLinksThemeProps) => {
  const { titleColor, menuBackground } = theme;

  return StyleSheet.create({
    wrapper: {
      position: 'relative',
      height: '100%',
      display: 'flex',
    },
    button: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: 'transparent',
      border: 'none',
      outline: 'none',
    },
    buttonTitle: {
      color: titleColor,
      marginRight: '9px',
    },
    menuBody: {
      listStyle: 'none',
      width: '100%',
      position: 'absolute',
      backgroundColor: menuBackground,
    },
  });
};

export const MoreLinksComponent:React.FunctionComponent<MoreLinksComponentProps> = props => {
  const { moreLinksText, links, pagePath } = props;
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const toggleMenu = React.useCallback(() => {
    setIsMenuOpen(!isMenuOpen);
  }, [isMenuOpen]);


  const style = getStyle(props);
  const titleStyle = StyleSheet.create(getGeneratedGlobalStyles().p());
  const chevronDirection = isMenuOpen ? Directions.UP : Directions.DOWN;

  return (
    <div className={css(style.wrapper)}>
      <button type="button" className={css(style.button)} onClick={toggleMenu}>
        <span className={css(titleStyle.style, style.buttonTitle)}>{moreLinksText}</span>
        <ChevronIcon direction={chevronDirection} />
      </button>
      {
        isMenuOpen && <DropDownMenu configThemeKey="moreLinks" menuLinks={links} highlightActive activeEndpoint={pagePath} />
        }
    </div>
  );
};


const mapThemeToProps = (theme: MoreLinksThemeProps) => (
  {
    titleColor: theme.titleColor,
    menuBackground: theme.menuBackground,
    linkColor: theme.linkColor,
    hoverColor: theme.hoverColor,
  }
);

export const MoreLinks = (props: MoreLinksProps) => {
  const themeContext = useTheme(componentConfigThemeKey, mapThemeToProps);
  return <MoreLinksComponent {...themeContext} {...props} />;
};
